import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaUserShield, FaLock } from 'react-icons/fa';
import './forgot.css';

const ForgotPassword = () => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        username: '',
        mothername: '',
        fathername: '',
        new_password: '',
        confirm_password: ''
    });
    
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    // const API = process.env.REACT_APP_API_URL || "http://127.0.0.1:1500";
    const API = process.env.REACT_APP_API_URL || "https://api.moulirobots.com";

    const handleInput = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleVerify = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${API}/api/verify-reset-info`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: formData.username,
                    mothername: formData.mothername,
                    fathername: formData.fathername
                }),
            });
            const result = await response.json();
            if (response.ok) {
                setStep(2);
                setError('');
            } else {
                setError(result.error);
            }
        } catch (err) {
            setError('Server connection failed.');
        }
    };

    const handleReset = async (e) => {
        e.preventDefault();
        if (formData.new_password !== formData.confirm_password) {
            setError("Passwords do not match!");
            return;
        }

        try {
            const response = await fetch(`${API}/api/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: formData.username,
                    new_password: formData.new_password
                }),
            });
            const result = await response.json();
            if (response.ok) {
                setMessage('Success! Redirecting to login...');
                setTimeout(() => navigate('/login'), 2000);
            } else {
                setError(result.error);
            }
        } catch (err) {
            setError('Update failed. Try again.');
        }
    };

    return (
        <div className="forgot-password-page">
            <div className="glass-overlay_for"></div>
            <button className="nav-icon-btn_for back" onClick={() => navigate('/login')}>
                <FaArrowLeft />
            </button>

            <main className="forgot-container">
                <div className="glass-card_for">
                    <div className="icon-header_for">
                        {step === 1 ? <FaUserShield className="icon-glow_for" /> : <FaLock className="icon-glow_for" />}
                    </div>

                    <h2 className="form-title_for">
                        {step === 1 ? <>Verify <span className="accent_for">Identity</span></> : <>New <span className="accent_for">Password</span></>}
                    </h2>

                    {step === 1 ? (
                        <form onSubmit={handleVerify} className="fade-in_for">
                            <p className="description_for">Enter your registered family details to proceed.</p>
                            <div className="input-group_for">
                                <input name="username" placeholder="UserName" onChange={handleInput} required />
                            </div>
                            <div className="input-group_for">
                                <input name="fathername" placeholder="Father's Name" onChange={handleInput} required />
                            </div>
                            <div className="input-group_for">
                                <input name="mothername" placeholder="Mother's Name" onChange={handleInput} required />
                            </div>
                            {error && <p className="status-msg_for error">{error}</p>}
                            <button className="submit-btn_for" type="submit">Verify Details</button>
                        </form>
                    ) : (
                        <form onSubmit={handleReset} className="fade-in_for">
                            <p className="description_for">Set a strong password for your account.</p>
                            <div className="input-group_for">
                                <input type="password" name="new_password" placeholder="New Password" onChange={handleInput} value={formData.new_password || ""} required />
                            </div>
                            <div className="input-group_for">
                                <input type="password" name="confirm_password" placeholder="Confirm Password" onChange={handleInput} value={formData.confirm_password || ""} required />
                            </div>
                            {error && <p className="status-msg_for error">{error}</p>}
                            {message && <p className="status-msg_for success">{message}</p>}
                            <button className="submit-btn_for success-btn_for" type="submit">Update Password</button>
                        </form>
                    )}
                </div>
            </main>
        </div>
    );
};

export default ForgotPassword;